import { DataSourceMyBagQueryProviderProps } from "./data-source--mybag-query-provider";

export type DataSource_MyBag_QueryKeyType = [
  string,
  Omit<DataSourceMyBagQueryProviderProps, "useInitialState">
];

const mybagBaseQuery = `bbnt-data-source-mybag-provider`;
export const DataSource_MyBag_QueryKey = {
  mybagBaseQuery,
  mybag: (
    desiredBag: DataSourceMyBagQueryProviderProps
  ): DataSource_MyBag_QueryKeyType => {
    const { useInitialState, ...desiredBag_cleaned } = {
      ...desiredBag,
    };

    const queryKey: DataSource_MyBag_QueryKeyType = [
      mybagBaseQuery,
      desiredBag_cleaned,
    ];

    return queryKey;
  },
};
